module.exports = __webpack_public_path__ + "static/rick-003-95db8874668c08567dbfca7fb8cf78c5.jpg";